export default __webpack_public_path__ + "static/media/playlist.12d4382e.svg";